import React from 'react';
export function Story() {
  return <div className="max-w-3xl mx-auto px-4 py-4" data-id="element-176">
      <p className="mb-6" data-id="element-177">
        I thought maybe she'd cut her gum. But when I looked closer, I saw the
        real problem: brown, crusted tartar covering her back teeth. Gums so red
        and swollen they were bleeding just from chewing.
      </p>
      <p className="mb-6" data-id="element-178">My vet's words hit like a truck:</p>
      <p className="mb-6" data-id="element-179">
        "She needs a dental cleaning. Three teeth may need extraction. We're
        looking at $800-$1,200."
      </p>
      <p className="mb-6" data-id="element-180">Luna was only 5 years old.</p>

      <p className="mb-6" data-id="element-181">And the worst part? I'd been trying. I really had.</p>

      <div className="my-8" data-id="element-182"></div>

      <p className="mb-6" data-id="element-183">For two years, I'd attempted everything:</p>
      <ul className="mb-6 space-y-2 ml-6" data-id="element-184">
        <li data-id="element-185">• Bought the fancy toothbrush kit (she bit me)</li>
        <li data-id="element-186">• Tried those "dental chews" (gone in 30 seconds, zero effect)</li>
        <li data-id="element-187">
          • Switched to "dental diet" kibble (her breath still smelled like
          death)
        </li>
      </ul>

      <p className="mb-6" data-id="element-188">
        Nothing worked. The tartar kept building. The smell kept getting worse.
      </p>

      <p className="mb-6" data-id="element-189">I felt like the world's worst dog mom.</p>

      <div className="my-8" data-id="element-190">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wgJgd7SHeXYEZDfLACtKAd/melao-11.png" alt="Dog teeth with tartar buildup and inflamed gums" className="w-full h-auto rounded-lg shadow-md" data-id="element-191" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-192">
          The tartar and gum inflammation were getting worse every day
        </p>
      </div>

      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-193">
        The Brushing Battle That Nearly Broke Me
      </h2>

      <p className="mb-6" data-id="element-194">
        After that vet visit, I committed to brushing her teeth daily.
      </p>
      <p className="mb-6" data-id="element-195">I lasted four days.</p>
      <p className="mb-6" data-id="element-196">
        Luna treated every attempt like I was trying to poison her. Wrestling.
        Growling. Once, she actually drew blood from my finger.
      </p>
      <p className="mb-6" data-id="element-197">
        Even when I managed to scrub for 30 seconds, her teeth still looked
        disgusting the next morning.
      </p>

      <p className="mb-6" data-id="element-198">When I told my vet, she said:</p>
      <p className="mb-6 italic" data-id="element-199">
        "Keep trying. Some dogs just need professional cleanings more often."
      </p>

      <p className="mb-6" data-id="element-200">
        More cleanings? More anesthesia? More $1,000 bills?
      </p>
      <p className="mb-6" data-id="element-201">I refused to believe that was my only option.</p>

      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-202">
        The Dog Park Conversation That Explained Everything
      </h2>

      <p className="mb-6" data-id="element-203">The breakthrough came at the dog park.</p>
      <p className="mb-6" data-id="element-204">
        A woman named Jennifer watched Luna play and said, "Wow, she's got so
        much energy for a senior dog!"
      </p>

      <p className="mb-6" data-id="element-205">"She's only five," I said.</p>
      <p className="mb-6" data-id="element-206">
        Jennifer looked confused. "Really? I just thought... her teeth looked—"
      </p>
      <p className="mb-6" data-id="element-207">"I know," I interrupted. "Trust me, I know."</p>

      <p className="mb-6" data-id="element-208">
        "My dog used to have the same problem," she said. "Brown buildup, awful
        breath, bleeding gums. Then I figured out what was really happening."
      </p>

      <div className="my-8" data-id="element-209">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7BFKn3SsGTjRkY4CCHQ9WV/melao-12.png" alt="Dog with healthy clean teeth and pink gums" className="w-full h-auto rounded-lg shadow-md" data-id="element-210" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-211">
          Healthy teeth and gums - what I wanted for Luna
        </p>
      </div>

      <p className="mb-6" data-id="element-212">
        She explained something my vet had never mentioned:
      </p>

      <p className="mb-6 font-bold" data-id="element-213">
        The real problem isn't just plaque. It's biofilm.
      </p>

      <p className="mb-6" data-id="element-214">
        Biofilm is an invisible, slimy bacterial shield that coats your dog's
        teeth. It's designed by nature to resist brushing, resist chewing,
        resist everything.
      </p>

      <p className="mb-6" data-id="element-215">That's why:</p>

      <ul className="mb-6 space-y-3" data-id="element-216">
        <li className="flex items-start" data-id="element-217">
          <span className="text-blue-600 mr-2 font-bold" data-id="element-218">•</span>
          <span data-id="element-219">Brushing barely helps (it can't penetrate the shield)</span>
        </li>
        <li className="flex items-start" data-id="element-220">
          <span className="text-blue-600 mr-2 font-bold" data-id="element-221">•</span>
          <span data-id="element-222">
            Dental chews don't work (they scrape the surface but miss the
            biofilm)
          </span>
        </li>
        <li className="flex items-start" data-id="element-223">
          <span className="text-blue-600 mr-2 font-bold" data-id="element-224">•</span>
          <span data-id="element-225">
            Bad breath keeps coming back (bacteria are protected underneath)
          </span>
        </li>
      </ul>

      <p className="mb-6 italic" data-id="element-226">
        "Your vet telling you to brush more is like telling you to wash a Teflon
        pan harder," she said. "You're fighting the wrong battle."
      </p>

      <p className="mb-6" data-id="element-227">
        For the first time in two years, everything clicked.
      </p>
      <p className="mb-6" data-id="element-228">It wasn't my fault. I wasn't a bad dog mom.</p>
      <p className="mb-6" data-id="element-229">
        I was fighting an invisible enemy I didn't know existed.
      </p>
    </div>;
}